const actionTypes = {
    UPDATE_SUBSCRIPTIONS: 'UPDATE_SUBSCRIPTIONS',
    UNSUBSCRIBE_AUTOREPLENISHMENT: 'UNSUBSCRIBE_AUTOREPLENISHMENT',
    LOAD_SHIPPING_AND_PAYMENT_INFO: 'LOAD_SHIPPING_AND_PAYMENT_INFO',
    LOAD_CREDIT_CARD_LIST: 'LOAD_CREDIT_CARD_LIST',
    UPDATE_AUTOREPLENISHMENT_SUBSCRIPTION: 'UPDATE_AUTOREPLENISHMENT_SUBSCRIPTION',
    CLEAR_SUBSCRIPTIONS: 'CLEAR_SUBSCRIPTIONS',
    LOAD_COUNTRIES: 'LOAD_COUNTRIES'
};

module.exports = actionTypes;
